module.exports = __webpack_public_path__ + "img/old_wooden_sign_image_not_found.482a5e11.jpg";